import { render, staticRenderFns } from "./watchData.vue?vue&type=template&id=87fe04b8&scoped=true"
import script from "./watchData.vue?vue&type=script&lang=js"
export * from "./watchData.vue?vue&type=script&lang=js"
import style0 from "./watchData.vue?vue&type=style&index=0&id=87fe04b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fe04b8",
  null
  
)

export default component.exports